'use client';

import '@repo/web-chrome/lib/api-client';
import type { SupportedLocaleType } from '@repo/config';
import { useState } from 'react';
import type { EnglishIqMessagesType } from './english-iq-messages-type';
import { EnglishIqWizardContent } from './english-iq-wizard-content';
import { useEnglishIqWizard } from './hooks';
import { EnglishIqTurnstile } from './turnstile';

interface IEnglishIqWizardProps {
  locale: SupportedLocaleType;
  messages: EnglishIqMessagesType;
  siteKey: string;
}

export function EnglishIqWizard({
  locale,
  messages,
  siteKey,
}: IEnglishIqWizardProps): React.JSX.Element {
  const wizard = useEnglishIqWizard(locale);
  const [executeSignal, setExecuteSignal] = useState(0);
  const requestStart = (): void => setExecuteSignal((value) => value + 1);

  return (
    <section
      id="english-iq-test"
      className="flex flex-1 flex-col px-4 pb-[max(1.5rem,env(safe-area-inset-bottom))] pt-[max(1.5rem,env(safe-area-inset-top))] sm:px-6 sm:py-16"
    >
      <div className="mx-auto flex w-full max-w-3xl flex-1 items-start sm:rounded-4xl sm:border sm:border-foreground/10 sm:bg-background/90 sm:p-10 sm:shadow-2xl sm:shadow-violet-500/10 sm:backdrop-blur">
        <div className="w-full">
          {wizard.error === 'answer' ? (
            <p className="mb-6 rounded-xl bg-red-500/10 p-3 text-center text-sm text-red-700 dark:text-red-300">
              {messages.wizard.errorBody}
            </p>
          ) : null}
          <EnglishIqWizardContent
            locale={locale}
            messages={messages}
            requestStart={requestStart}
            wizard={wizard}
          />
        </div>
      </div>
      <EnglishIqTurnstile
        executeSignal={executeSignal}
        onError={wizard.markStartFailed}
        onToken={wizard.start}
        siteKey={siteKey}
      />
    </section>
  );
}
